/**
 * The loop host's authentication: a bearer token minted for one run when it starts
 * (`v3.runs.start`), stored only as its SHA-256 (`orcaloops_v3.runs.host_token_hash`).
 * A verified call carries the run it belongs to; the host can read and write only that
 * run.
 *
 * @since 1.0.0
 */
import { RpcMiddleware } from "@effect/rpc";
import { Context, Schema } from "effect";

/**
 * The run a host call is for.
 *
 * @since 1.0.0
 */
export class V3HostCaller extends Context.Tag("V3HostCaller")<
  V3HostCaller,
  {
    readonly runId: string;
    readonly customerId: string;
  }
>() {}

/**
 * @since 1.0.0
 */
export class V3HostUnauthorized extends Schema.TaggedError<V3HostUnauthorized>()("V3HostUnauthorized", {
  reason: Schema.Literal("missing", "invalid", "finished"),
  message: Schema.String,
}) {}

/**
 * @since 1.0.0
 */
export class V3HostMiddleware extends RpcMiddleware.Tag<V3HostMiddleware>()("V3HostMiddleware", {
  provides: V3HostCaller,
  failure: V3HostUnauthorized,
  requiredForClient: true,
}) {}
